/**
 * フォームの情報
 */
const headTitleList: any[] = [
  {
    headTitle: "申請・届出（手続き）",
  },
  {
    headTitle: "共済契約者",
  },
  {
    headTitle: "契約者最終処理日時",
  },
  {
    headTitle: "案内送付日",
  },
  {
    headTitle: "対応期日",
  },
  {
    headTitle: "対応期日との乖離",
  },
  {
    headTitle: "督促回数",
  },
  {
    headTitle: "直近督促日",
  },
  {
    headTitle: "担当者",
  },
];

export { headTitleList };
